export const EXTERNAL_WEBSITE = {
  label: 'External Website',
  value: 'external-website',
  tabs: ['profile-viewer', 'integrations', 'decisioning-surfaces', 'data-elements', 'rules'],
  hidden: true,
}
